import { FC } from 'react';
import { Box } from '@chakra-ui/layout';
import { Crucible } from 'types';
import CrucibleTabs from 'components/crucible/detail/CrucibleTabs';

type Props = {
  crucible: Crucible;
};

const CrucibleDetailCard: FC<Props> = ({ crucible }) => {
  return (
    <Box p={[4, null, 10]} bg='gray.800' borderRadius='xl'>
      <CrucibleTabs crucible={crucible!} />
    </Box>
  );
};

export default CrucibleDetailCard;
